<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Stores
	import SportBetLegStore from '@/Stores/Sport/BetLegStore.js';
	// Partials
	import BetList from '@/Partials/Sport/Markets/_BetsList.svelte';
	// Models
	import Market from '@/Models/Market';
	// Services
	import ApiService from '@/Services/ApiService';

	export let market;
	export let event;

	let loading = getLegsForMarket();

	function getLegsForMarket() {
		if (market) {
			return SportBetLegStore.getLegsForMarket(market.id);
		}
	}

	function downloadSportSelectionBets() {
		const marketModel = new Market();
		ApiService.downloadFile(
			`${marketModel.baseUrl()}/markets/${market.id}/legs/export`,
			`${event.name} ${market.name} bets - ${dayjs().format('YYYYMMDDHHmmss')}`
		);
	}
</script>

<BetList
	bind:selection_id={market.id}
	selection_type={'market_id'}
	export_bet_list={downloadSportSelectionBets}
	bind:loading
/>
